import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as Events from '../lib/events';

export default el => {
    const dom = $(el);
    const bar = dom.find('[data-bar]');
    const progress = dom.find('[data-progress]');
    const sections = dom.find('[data-section]');
    const subsections = dom.find('[data-subsection]');
    const expandables = dom.find('a[aria-expanded]');

    let lastSection = null;
    let active = false;

    const windowHeight = () => (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0);
    const windowScroll = () => (window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop || 0);
    const documentHeight = () => Math.max(
        document.body.scrollHeight || 0,
        document.documentElement.scrollHeight || 0,
        document.body.offsetHeight || 0,
        document.documentElement.offsetHeight || 0,
        document.body.clientHeight || 0,
        document.documentElement.clientHeight || 0
    );

    const update = () => {
        const percent = (windowScroll() / (documentHeight() - windowHeight())) * 100;
        progress.width(`${percent}%`);
    };

    const resetAndExpand = section => {
        expandables.attr('aria-expanded', false);
        expandables.each(node => {
            $(node).next().attr('hidden', '');
        });
        if (expandables.contains(section) && section !== lastSection) {
            $(section).attr('aria-expanded', true);
            $(section).next().attr('hidden', null);
        }
        lastSection = section;
    };

    const open = () => {
        if (!active) {
            active = true;
            dom.addClass('-open');
            bar.attr('aria-expanded', true);
        }
    };

    const close = () => {
        if (active) {
            active = false;
            dom.removeClass('-open');
            bar.attr('aria-expanded', false);
        }
    };

    const toggle = e => {
        e.preventDefault();
        Dispatch.emit(bar.attr('aria-expanded') === 'false' ? Events.PROJECTMENU_OPEN : Events.PROJECTMENU_CLOSE, dom);
    };

    const sectionClick = e => {
        e.preventDefault();
        resetAndExpand(e.triggerTarget);
        const section = $(e.triggerTarget);
        const scrollTarget = $(section.attr('href'));
        const offset = scrollTarget.position().top;
        TweenLite.to(window, 1, { scrollTo: { y: offset, autoKill: false }, ease: Cubic.easeInOut });
    };

    const subSectionClick = e => {
        e.preventDefault();
        const target = $(e.triggerTarget);
        const scrollTarget = $(target.attr('href'));
        const offset = scrollTarget.position().top;
        TweenLite.to(window, 1, { scrollTo: { y: offset, autoKill: false }, ease: Cubic.easeInOut });
    };

    const init = () => {
        Dispatch.on(Events.PROJECTMENU_OPEN, open);
        Dispatch.on(Events.PROJECTMENU_CLOSE, close);
        Viewport.on('scroll', update);
        Viewport.on('resize', update);
        bar.on('click', toggle);
        sections.on('click', sectionClick);
        subsections.on('click', subSectionClick);
        update();
    };

    const destroy = () => {
        Dispatch.off(Events.PROJECTMENU_OPEN, open);
        Dispatch.off(Events.PROJECTMENU_CLOSE, close);
        Viewport.off('scroll', update);
        Viewport.off('resize', update);
        bar.off('click');
        sections.off('click', sectionClick);
        subsections.off('click', subSectionClick);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/ProjectNavigation.js